<template>
  <nuxt-page></nuxt-page>
</template>
<script lang="ts">
export default {
  // DO NOT MODIFY THIS COMPONENT / PAGE. ITS USED BY OTHER PAGES A PARENT COMPONENT IN THEIR ROUTERS.
};
</script>
